<section id="best-token-airdrop" appScrollAnimation>
  <div class="container">
    <div class="best-tocken-wrapper">
      <div class="best-tocken-para">
        <p class="labels font-16">{{"coming" | translate}}</p>
        <h2 class="heading">
          {{"best-token-airdrop-title" | translate}}
        </h2>
        <p class="para1">
          {{"best-token-airdrop-para" | translate}}
        </p>

        <!-- <div class="btn-textt">
          <a class="best-wallet-link" href="https://bestwallet.com/airdrop" target="_blank">Get Started</a>
        </div> -->

      </div>
      <div class="best-tocken-img">
        <img src="assets/images/best-airdrop.svg" alt="">
      </div>
    </div>
    <!-- <div class="m-btn-textt">
      <a class="m-best-wallet-link" href="https://bestwallet.com/airdrop" target="_blank">Get Started</a>
    </div> -->
  </div>
</section>